import templateUrl from "./icd-corporation-dashboard-corporation-details.component.html";
import "./icd-corporation-dashboard-corporation-details.component.less";
import { IcdCorporationDetail } from "../icd-corporation-dashboard-types";
import { PermissionGrant } from "@herbjoy/apex-api-models";

export const IcdCorporationDashboardCorporationDetailsComponent = {
    templateUrl,
    bindings: {
        icdCorporationDetails: "<",
        permissionGrants: "<"
    },
    controller: class {
        icdCorporationDetails: IcdCorporationDetail;
        permissionGrants: PermissionGrant[];

        companyLogoHref: string;
        constructor(private apexApiUrl: string) {
            'ngInject';
        }

        $onChanges() {
            this.companyLogoHref = `${this.apexApiUrl}corporations/${this.icdCorporationDetails.Id}/logo`;
        }
    }
};
